import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaClipboard, FaNewspaper, FaHospital, FaBuilding, FaFile, FaFolderOpen } from 'react-icons/fa';
import '../styles/Sidebar.css';

const Sidebar = () => {
    const location = useLocation();

    const menuItems = [
        { path: '/post-types', icon: FaClipboard, label: 'Post Type' },
        { path: '/posts', icon: FaNewspaper, label: 'Posts' },
        { path: '/facility-types', icon: FaHospital, label: 'Facility Type' },
        { path: '/health-facilities', icon: FaBuilding, label: 'Health Facility' },
        { path: '/documents', icon: FaFile, label: 'Documents' },
        { path: '/health-facility-documents', icon: FaFolderOpen, label: 'Health Facility Documents' },
    ];

    return (
        <div className="sidebar bg-light">
            <nav className="sidebar-nav">
                <ul className="nav flex-column">
                    {menuItems.map((item) => (
                        <li className="nav-item" key={item.path}>
                            <Link
                                to={item.path}
                                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                            >
                                <item.icon className="me-2" /> {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default Sidebar;
